import React from 'react';

import { ReactComponent as Icon } from 'assets/img/vectors/impersonation.svg';

const ImpersonationIcon = ({ fill, ...props }) => (
   <Icon {...props} fill={(fill ? fill : '#666666')} />
);

export default ImpersonationIcon;
